import React from "react";
import { HiOutlineDocumentReport } from "react-icons/hi"; // Para o ícone do cabeçalho
import { FcReading } from "react-icons/fc"; // Para o ícone de 'ver relatório' em cada item
import { useNavigate } from 'react-router-dom'; // Para a navegação entre as rotas
import './Relatorios.css'; // Seu arquivo CSS para estilos

const Agendamentos = () => { 
  const navigate = useNavigate(); 

  
  const reportTypes = [
    { id: 'relatorioCompleto', title: 'Relatório Completo', path: '/relatorios' },

  ];

  
  const handleViewReport = (path) => {
    navigate(path);
  };

  return (
  
    <div className="agendamentos-container">

      {/* Cabeçalho do Bloco de Relatórios */}
      <div className="agendamentos-header">
        <HiOutlineDocumentReport size="30"/>
        <p>Relatórios</p>
      </div>

      {/* Lista dos Tipos de Relatórios */}
      {/* Reutiliza a classe 'agendamentos-list' para manter o padrão visual */}
      <div className="agendamentos-list">
        {reportTypes.map((report) => (
          <div key={report.id} className="agendamento-item"> {/* Reutiliza a classe 'agendamento-item' */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
              <p>
                <strong>{report.title}</strong>
              </p>
              <div style={{ display: 'flex', gap: '10px' }}>
                <FcReading
                  size="25"
                  color="#007bff" // Cor azul para o ícone, similar ao botão de editar
                  onClick={() => handleViewReport(report.path)}
                  style={{ cursor: 'pointer' }}
                  title={`Ver ${report.title}`}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Agendamentos;